// Numeric dotted-version comparison for the native minimum-version gate.

function parts(version: string): number[] {
  return version.split('.').map((segment) => Number.parseInt(segment, 10) || 0)
}

/** Negative when a < b, 0 when equal, positive when a > b. Missing segments count as 0. */
export function compareVersions(a: string, b: string): number {
  const left = parts(a)
  const right = parts(b)
  const length = Math.max(left.length, right.length)
  for (let i = 0; i < length; i++) {
    const diff = (left[i] ?? 0) - (right[i] ?? 0)
    if (diff !== 0) return diff
  }
  return 0
}

/** True when `current` is older than a non-empty `minimum`. */
export function isBelowMinimum(current: string, minimum: string): boolean {
  return minimum !== '' && compareVersions(current, minimum) < 0
}
